import { Logger } from 'sierra-client/core/logging/logger'

export const inviteUsersUserInviteOpened = Logger.trackLogger('user_invite_opened', false)

export const inviteUsersEditAttributesOpened = Logger.trackLogger<{ emails: string[] }>(
  'user_invite_edit_attributes',
  false
)
